export const reviews: Array<[string, string, string, string, string]> = [
  [
    'MG',
    'María G.',
    'Docente de Yacimientos de Hidrocarburos · Buenos Aires',
    'En una tarde tenía más material sobre yacimientos y sistemas petroleros contextualizado en Argentina que en toda mi carrera profesional. Ahora mis alumnos y colegas me preguntan sobre geología del petróleo, trampas geológicas, Vaca Muerta, cuencas sedimentarias, evaluación de reservorios y tengo respuesta fundamentada para todo. El impacto es visible desde la primera semana.',
    'bg-field',
  ],
  [
    'RT',
    'Rodrigo T.',
    'Instructor de Geología Petrolera · Santa Cruz',
    'Mis estudiantes por primera vez entendieron la diferencia entre un prospecto exploratorio y un yacimiento desarrollado, y analizaron casos reales de descubrimientos en Argentina con marcos técnicos vigentes. El nivel de participación en las clases se multiplicó y empezaron a ver los yacimientos como sistemas complejos, no como conceptos abstractos.',
    'bg-earth',
  ],
  [
    'SP',
    'Sandra P.',
    'Coordinadora de Formación en Petróleo y Gas · Córdoba',
    'Las simulaciones de caracterización de yacimientos con las plantillas del MEGAPACK son exactamente lo que necesitaba: checklists reales, cuencas argentinas, normativas vigentes, casos de empresas exploradoras argentinas, estrategias de evaluación aplicables. Cambió la forma en que planifico todo el año.',
    'bg-field-soft',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'FM',
    'Federico M.',
    'Buenos Aires · Megapack Yacimientos de Hidrocarburos',
    'Con el MEGAPACK, en una tarde tenía el marco conceptual completo para explicar por qué los yacimientos son sistemas complejos, qué procesos geológicos permiten la acumulación, cuáles son las principales cuencas argentinas, y por qué cada descubrimiento representa millones de años de procesos. Mis alumnos empezaron a ver los yacimientos como realidades científicas profundas. Porque lo son.',
  ],
  [
    'RV',
    'Rosa V.',
    'Neuquén · Megapack Yacimientos de Hidrocarburos',
    'Cuando explicás que los yacimientos no son accidentes sino productos de sistemas bien definidos, que Argentina tiene cuencas petroleras específicas, que Vaca Muerta es un hito tecnológico, que la exploración es una disciplina rigurosa basada en riesgo geológico, empieza un debate sobre energía, territorio y futuro que ninguna otra asignatura genera con esa profundidad.',
  ],
  [
    'GN',
    'Gabriela N.',
    'Santa Cruz · Megapack Yacimientos de Hidrocarburos',
    'Cuando mis alumnos descubren que Argentina tiene yacimientos convencionales y no convencionales, que existen empresas exploradoras transformando la industria, que la caracterización de yacimientos es una competencia profesional real, que el análisis de riesgos geológicos puede identificar futuras reservas, empieza una conversación sobre energía, innovación y oportunidades laborales que ningún libro de texto puede provocar.',
  ],
  [
    'AS',
    'Alejandro S.',
    'Río Negro · Megapack Yacimientos de Hidrocarburos',
    'Cerré mi planificación anual de Yacimientos de Hidrocarburos en dos horas. Antes me llevaba semanas. Ahora tengo todo el año organizado con información actualizada sobre cuencas argentinas, 100 casos para analizar, 150 actividades listas, 50 checklists para usar, 100 láminas para proyectar y evaluación integrada.',
  ],
  [
    'SM',
    'Sofía M.',
    'Mendoza · Megapack Yacimientos de Hidrocarburos',
    'Cuando les digo a mis alumnos que el explorador de yacimientos que trabaja en una cuenca argentina está haciendo lo mismo que los especialistas en hidrocarburos de las grandes corporaciones internacionales: identificando trampas, evaluando riesgos geológicos, caracterizando yacimientos, tomando decisiones en condiciones de incertidumbre, contribuyendo al desarrollo energético argentino, les estoy enseñando lo que significa ser un profesional responsable en el mundo real.',
  ],
];
